(function () {
  var productTypeCache = new Map();
  var updateToken = 0;

  function excludedTypes(element) {
    return new Set(
      (element.dataset.excludedProductTypes || '')
        .split(/\r?\n/)
        .map(function (value) { return value.trim().toLowerCase(); })
        .filter(Boolean)
    );
  }

  function currencyRate() {
    if (window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate)) {
      return Number(window.Shopify.currency.rate);
    }
    return 1;
  }

  function currencyCode() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    if (window.theme && window.theme.currencyCode) {
      return window.theme.currencyCode;
    }
    return 'AUD';
  }

  function formatMoney(cents) {
    var amount = Math.max(0, Number(cents) || 0) / 100;
    var options = {
      style: 'currency',
      currency: currencyCode(),
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    };

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', options).format(amount);
    } catch (error) {
      return new Intl.NumberFormat('en-AU', options).format(amount);
    }
  }

  function productJsonUrl(item) {
    if (item.handle) {
      return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'products/' + item.handle + '.js';
    }

    if (!item.url) return '';

    var path = item.url.split('?')[0];
    if (!/\/products\//.test(path)) return '';
    return path.replace(/\/$/, '') + '.js';
  }

  function productType(item) {
    if (typeof item.product_type === 'string') {
      return Promise.resolve(item.product_type);
    }

    var cacheKey = String(item.product_id || item.handle || item.url || '');
    if (productTypeCache.has(cacheKey)) {
      return Promise.resolve(productTypeCache.get(cacheKey));
    }

    var url = productJsonUrl(item);
    if (!url) {
      productTypeCache.set(cacheKey, '');
      return Promise.resolve('');
    }

    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load product metadata');
        return response.json();
      })
      .then(function (product) {
        var type = product.type || product.product_type || '';
        productTypeCache.set(cacheKey, type);
        return type;
      })
      .catch(function () {
        productTypeCache.set(cacheKey, '');
        return '';
      });
  }

  function cartShippingState(cart, excluded) {
    var items = Array.isArray(cart.items) ? cart.items : [];

    return Promise.all(
      items.map(function (item) {
        return productType(item).then(function (type) {
          var normalizedType = String(type || '').trim().toLowerCase();
          var isBulky = normalizedType && excluded.has(normalizedType);

          return {
            isBulky: Boolean(isBulky),
            eligibleValue: isBulky ? 0 : (Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0)
          };
        });
      })
    ).then(function (states) {
      return states.reduce(function (result, state) {
        result.hasBulkyItem = result.hasBulkyItem || state.isBulky;
        result.eligibleSubtotal += state.eligibleValue;
        return result;
      }, { hasBulkyItem: false, eligibleSubtotal: 0 });
    });
  }

  function updateElement(element, state) {
    var baseThreshold = Number(element.dataset.limitBaseCents) || 0;
    var threshold = Math.round(baseThreshold * currencyRate());
    if (threshold <= 0) return;

    var eligibleCents = state.eligibleSubtotal;
    var hasBulkyItem = state.hasBulkyItem;
    var left = Math.max(0, threshold - eligibleCents);
    var percent = Math.min(100, Math.max(0, eligibleCents / threshold * 100));
    var amount = element.querySelector('[data-left-to-spend]');
    var progress = element.querySelector('[data-cart-progress]');
    var graph = element.querySelector('[data-free-shipping-graph]');
    var bulkyMessage = element.querySelector('[data-bulky-shipping-message]');
    var successMessage = element.querySelector('.cart__message-success');
    var defaultMessage = element.querySelector('.cart__message-default');
    var hasSuccessMessage = element.dataset.cartMessage === 'true';
    var qualified = !hasBulkyItem && eligibleCents >= threshold;

    element.dataset.eligibleSubtotal = String(eligibleCents);
    element.dataset.hasBulkyItem = hasBulkyItem ? 'true' : 'false';

    if (hasBulkyItem) {
      element.classList.remove('is-success', 'is-hidden');
      if (graph) graph.hidden = true;
      if (bulkyMessage) bulkyMessage.hidden = false;
      if (successMessage) successMessage.hidden = true;
      if (defaultMessage) defaultMessage.hidden = true;
      return;
    }

    if (graph) graph.hidden = false;
    if (bulkyMessage) bulkyMessage.hidden = true;
    if (successMessage) successMessage.hidden = false;
    if (defaultMessage) defaultMessage.hidden = false;

    if (amount) {
      amount.textContent = formatMoney(left);
    }

    if (progress) {
      progress.dataset.percent = String(percent);
      var circumference = 87.96459430051421;
      progress.style.strokeDashoffset = String(circumference - (percent / 100 * circumference));
    }

    if (qualified && hasSuccessMessage) {
      element.classList.add('is-success');
      element.classList.remove('is-hidden');
    } else if (qualified) {
      element.classList.add('is-hidden');
      element.classList.remove('is-success');
    } else {
      element.classList.remove('is-success', 'is-hidden');
    }
  }

  function update(cart) {
    var token = ++updateToken;
    var elements = Array.from(document.querySelectorAll('[data-free-shipping-progress]'));
    if (!elements.length || !cart) return;

    var groups = new Map();

    elements.forEach(function (element) {
      var raw = element.dataset.excludedProductTypes || '';
      if (!groups.has(raw)) groups.set(raw, []);
      groups.get(raw).push(element);
    });

    groups.forEach(function (groupElements) {
      var excluded = excludedTypes(groupElements[0]);

      cartShippingState(cart, excluded).then(function (state) {
        if (token !== updateToken) return;
        groupElements.forEach(function (element) {
          updateElement(element, state);
        });
      });
    });
  }

  function fetchCartAndUpdate() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(update)
      .catch(function () {});
  }

  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      update(event.detail.cart);
    } else {
      fetchCartAndUpdate();
    }
  });

  document.addEventListener('theme:cart:init', function (event) {
    if (event.detail && event.detail.cart) {
      update(event.detail.cart);
    } else {
      fetchCartAndUpdate();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndUpdate, { once: true });
  } else {
    fetchCartAndUpdate();
  }
})();
